import { takeEvery, takeLatest, throttle } from 'redux-saga/effects';
import {
  zoomLevelChanged,
  zoomPositionChanged,
  zoomReset,
} from 'features/content-zoom/contentZoomSlice';
import { signalingLockedContentZoomUpdated } from 'features/content-zoom/actions';
import {
  signalingContentUnlocked,
  contentUnlocked,
} from 'features/layout/features/content/actions';
import { sendLockedContentZoomSaga } from 'features/content-zoom/sagas/sendLockedContentZoomSaga';
import { onLockedContentZoomUpdatedSaga } from 'features/content-zoom/sagas/onLockedContentZoomUpdatedSaga';
import { onContentUnlockedSaga } from 'features/content-zoom/sagas/onContentUnlockedSaga';

export default function* contentZoomWatcher() {
  yield takeLatest(zoomLevelChanged, sendLockedContentZoomSaga);
  yield takeLatest(zoomReset, sendLockedContentZoomSaga);
  yield throttle(100, zoomPositionChanged.type, sendLockedContentZoomSaga);
  yield takeEvery(signalingLockedContentZoomUpdated, onLockedContentZoomUpdatedSaga);
  yield takeEvery(signalingContentUnlocked, onContentUnlockedSaga);
  yield takeEvery(contentUnlocked, onContentUnlockedSaga);
}
